module.exports = __WEBPACK_EXTERNAL_MODULE_PbPb__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"lodash","commonjs2":"lodash","amd":"lodash","root":"_","var":"_"}
// module id = PbPb
// module chunks = 0